export default "__VITE_ASSET__51a10200__"